<template>
  <v-container>
    <v-layout row wrap justify-center mb-4>
      <v-flex xs12 md8>
        <v-card dark>
          <v-card-title>
            <v-layout row wrap justify-center>
              <v-flex xs6 text-xs-center>
                <h2 class="headline">Frequently Asked Questions</h2>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center>
      <v-flex xs8>
        <v-expansion-panel>
          <v-expansion-panel-content v-for="(faq, ix) in faqs" :key="ix">
            <template v-slot:header>
              <v-flex xs12>
                {{ix + 1}} - {{faq.question}}
              </v-flex>
            </template>
            <v-card>
              <v-divider />
              <v-card-text class="pa-2">
                <v-layout row wrap>
                  <v-flex xs12 pa-2>
                      {{faq.answer}}
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import SplashBanner from '@/components/SplashBanner'
import { faqs } from '@/data/faqs.json'

export default {
  components: {
    SplashBanner
  },
  data () {
    return {
      faqs
    }
  }
}
</script>
<style>
#pushDown {
  margin-top: 200px;
}
</style>
